import React from 'react';
import { observer } from 'mobx-react';

import type { AccordionHeaderProps } from 'shared/Accordion/components/AccordionWrapper';
import AccordionFormHeader from '../AccordionFormHeader';

export interface PackingDeclarationHeaderProps extends AccordionHeaderProps {
  completed: boolean;
}

const PackingDeclarationHeader = ({
  expanded,
  completed,
}: PackingDeclarationHeaderProps) => (
  <AccordionFormHeader
    expanded={expanded}
    headline={I18n.translate('exports.form.packing_declaration.header')}
    completed={completed}
  />
);

export default observer(PackingDeclarationHeader);
